export const DEFAULT_SUGGESTION_PERIOD: 'months' | 'years' | 'days' = 'years';
export const DEFAULT_SUGGESTIONS_PERIOD_NUMBER: number = -3;
export const DEFAULT_SUGGESTIONS_PAGE_SIZE: number = 8;
